import React from "react"
import Image from "../../imagev2"
import tw, { css } from "twin.macro"
const BlogImagen = ({ content }) => {
  const { data } = content
  const block = data.blocks[0]
  return (
    <div css={tw`my-6 pb-1`}>
      <Image
        objectFit={"contain"}
        imageTablet={block.image}
        imageMobile={block.image_mobile}
        widths={["880px", "980px", "1200px"]}
      />
      {block.texto_con_formato2 && (
        <div
          css={[cssTexto]}
          dangerouslySetInnerHTML={{ __html: block.texto_con_formato2 }}
        />
      )}
    </div>
  )
}

export default BlogImagen
const cssTexto = css`
  &,
  & * {
    ${tw`text-obsssmall2 leading-16em md:text-obsmall md:leading-loose`}
  }
`
